define('models/AdvantageCollection',['underscore', 'app', 'ObjectCollection', 'models/AdvantageModel'],
    function (_, app, ObjectCollection, AdvantageModel)
    {
        //
        // Collection AdvantageCollection
        //
        var AdvantageCollectionPrototype = {

            name: 'AdvantageCollection',
            model: AdvantageModel,

            initialize:function(models, options){

                var collection = this;

                if(collection.group){
                    collection.group = options.group;
                }

                ObjectCollection.prototype.initialize.apply(collection,arguments);
            },

            getUsableAdvantages:function(onCart){
                return _(this.filter(function(advantage){
                    return advantage.isUsable(onCart);
                }));
            }

        };
        var AdvantageCollection = ObjectCollection.extend(AdvantageCollectionPrototype);

        return AdvantageCollection;
    });
